import { Col, Row } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import totalClientIcon from '../../assets/total_client.svg'
import activeClientIcon from '../../assets/active_client.svg'
import totalBalIcon1 from '../../assets/total_balance_i1.svg'
import totalBalIcon2 from '../../assets/total_balance_i2.svg'
import totalProfitIcon from '../../assets/total_profit.svg'

function Dashboard() {
    const [dashboard, setDashboard] = useState();

    useEffect(() => {
        fetchDashboardData()
    }, [])

    const fetchDashboardData = (val) => {
        axios.get(`${process.env.REACT_APP_ADMIN_API_URL}admin/admin-dashboard`, {
            headers: {
                'x-product-type': 'MAKE_MY_PROFIT'
            }
        })
            .then(res => {
                let productSales = res.data.productSales || [];
                setDashboard({ ...res.data, productSales });
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <Row gutter={[20, 20]}>
            <Col span={24}>
                <Row gutter={[20, 20]}>
                    {/* <Col span={6}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#00C39A", padding: "50px 10px 24px 10px", textAlign: "center" }}>
                                    <h3>{dashboard?.totalRequests?.toLocaleString("hi-IN") || 0}</h3>
                                    <span style={{ marginBottom: 34 }}>Total Request</span>
                                    <img src={PendingUserIcon} style={{ width: "244px", margin: "auto" }} />
                                </div>
                            </Col>
                        </Row>
                    </Col> */}
                    <Col span={12}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FFD155", padding: "86px 10px 86px 50px" }}>
                                    <h3>{(dashboard?.totalUsers)?.toLocaleString("hi-IN") || 0}</h3>
                                    <span>Total users</span>
                                    <img src={totalBalIcon1} style={{ width: "70px", top: 24, left: 24 }} className='position' />
                                    <img src={totalBalIcon2} style={{ width: "147px", bottom: 18, right: 25 }} className='position' />
                                </div>
                            </Col>
                            <Col span={10}>
                                <div className='dashboard-block' style={{ backgroundColor: "#f9a19e", padding: "45px 10px 45px 25px" }}>
                                    <h3>{dashboard?.inactiveUsers || 0}</h3>
                                    <span>Inactive Users</span>
                                    <img src={totalClientIcon} style={{ width: "40px", top: 13, right: 12 }} className='position' />
                                </div>
                            </Col>
                            <Col span={14}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FF904B", padding: "45px 10px 45px 50px" }}>
                                    <h3>{dashboard?.activeUsers || 0}</h3>
                                    <span>Active Users</span>
                                    <img src={activeClientIcon} style={{ width: "50px", top: 13, right: 29 }} className='position' />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row gutter={[20, 20]}>
                            <Col span={24}>
                                <div className='dashboard-block' style={{ backgroundColor: "#FCC699", padding: "40px 10px 20px 10px", textAlign: "center" }}>
                                    <h3>${dashboard?.totalDepositAmount?.toLocaleString("hi-IN") || 0}</h3>
                                    <span style={{ marginBottom: 34 }}>Total Deposite amount</span>
                                    <img src={totalProfitIcon} style={{ width: "283px", margin: "auto" }} />
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    {/* <Col span={24}>
                        <Row gutter={[20, 20]}>
                            {dashboard?.productSales?.map((product, index) => {
                                const { color, icon1, icon2, span } = productConfig[product.productName] || { color: "#ddd", icon1: null, icon2: null };

                                return (
                                    <Col span={span} key={index}>
                                        <div className='dashboard-block' style={{
                                            backgroundColor: color,
                                            padding: "100px 20px 80px 30px",
                                            textAlign: "center",
                                            position: "relative"
                                        }}>
                                            <h3>{product.productSelling.toLocaleString("hi-IN")}</h3>
                                            <span>{product.productName} ({product.saleCount  || 0})</span>

                                            {icon1 && <img src={icon1} style={{ width: "50px", position: "absolute", top: "15px", left: "15px" }} />}
                                            {icon2 && <img src={icon2} style={{ width: "50px", position: "absolute", bottom: "15px", right: "15px" }} />}
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Col> */}
                </Row>
            </Col>
        </Row>
    )
}

export default Dashboard